import React from "react";

import { Models } from "api/types";
import Plus from "atoms/icon/icons/ic_plus_large_ol.svg";
import Rewards from "atoms/icon/icons/rewards.svg";
import { MembershipRewards } from "organisms/membership-rewards/MembershipRewards";
import { useFeatureFlag } from "services/Flags";

type MonthlyRewardsOrTreatmentsProps = {
  membershipsRewards: Models<"MembershipRewardGroupModel">[];
  membershipBillingPeriodInterval?: string;
  membershipBillingPeriodIntervalCount?: number;
  flagBeautyBank: boolean;
  hasAnyImagesOnPage?: boolean;
};

const MonthlyRewardsOrTreatments: React.FC<MonthlyRewardsOrTreatmentsProps> = ({
  membershipsRewards,
  membershipBillingPeriodInterval,
  membershipBillingPeriodIntervalCount,
  flagBeautyBank,
  hasAnyImagesOnPage = false,
}) => {
  const isFlexibleMembershipsEnabled = useFeatureFlag(
    "flexible_membership_terms"
  );

  return (
    <>
      {membershipsRewards
        .filter(
          (rg) =>
            !!rg &&
            (isFlexibleMembershipsEnabled
              ? rg.billingPeriodInterval > 0
              : rg.periodMonths > 0)
        )
        .map((rg, index) => {
          if (
            !rg.hasSelectableRewards &&
            (!rg.membershipRewards || rg.membershipRewards.length === 0)
          ) {
            return null;
          }

          const SvgIcon = index === 0 ? Rewards : Plus;

          return (
            <MembershipRewards
              key={index}
              membershipRewards={rg.membershipRewards}
              rewardGroup={rg}
              svg={SvgIcon}
              billingPeriodsBeforeFirstReward={
                isFlexibleMembershipsEnabled
                  ? rg.billingPeriodsBeforeFirstReward
                  : rg.monthsBeforeFirstReward
              }
              billingPeriodInterval={
                isFlexibleMembershipsEnabled
                  ? rg.billingPeriodInterval
                  : rg.periodMonths
              }
              membershipBillingPeriodInterval={membershipBillingPeriodInterval}
              membershipBillingPeriodIntervalCount={
                membershipBillingPeriodIntervalCount
              }
              isSelectable={rg.hasSelectableRewards}
              quantityPerPeriod={rg.quantityPerPeriod}
              flagBeautyBank={flagBeautyBank}
              hasAnyImagesOnPage={hasAnyImagesOnPage}
            />
          );
        })}
    </>
  );
};

export default MonthlyRewardsOrTreatments;
